import React from 'react'
import { connect } from 'react-redux'
import { Menu, Layout } from 'antd'
import classNames from 'classnames'
import store from 'store'
import { find } from 'lodash'
import { withRouter } from 'router'
import SimpleBar from 'simplebar-react'
import { isGlobal } from 'conf'
import i18n from 'i18n'
import { openInquiryConfirm } from 'components/cleanui/layout/InquiryModal'

import styles from './style.module.scss'

const mapStateToProps = ({ menu, settings, user, dispatch }) => ({
  menuData: menu.menuData,
  adminMenuData: menu.adminMenuData,
  isMenuCollapsed: settings.isMenuCollapsed,
  isSidebarOpen: settings.isSidebarOpen,
  isMobileView: settings.isMobileView,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  menuColor: settings.menuColor,
  // logo: settings.logo,
  role: user.role,
  workspace: user.workspace,
  userEmail: user.email,
  dispatch,
})

class MenuLeft extends React.Component {
  state = {
    selectedKeys: store.get('app.menu.selectedKeys') || ['dashboardnine'],
    openedKeys: store.get('app.menu.openedKeys') || ['email', 'group1'],
    isMobile: window.innerWidth <= 1029,
  }

  menuKeyMap = []

  componentDidMount() {
    this.applySelectedKeys()
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps /* , prevState */) {
    const { location, menuData, adminMenuData, menuType } = this.props
    if (
      prevProps.menuType !== menuType ||
      prevProps.location.pathname !== location.pathname ||
      (prevProps.menuType === 'admin' && prevProps.adminMenuData !== adminMenuData) ||
      (prevProps.menuType === 'user' && prevProps.menuData !== menuData)
    ) {
      this.applySelectedKeys()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 1029 })
  }

  applySelectedKeys = () => {
    const {
      location: { pathname },
      menuData: userMenuData,
      adminMenuData,
      menuType,
    } = this.props

    const menuData = menuType === 'admin' ? adminMenuData : userMenuData

    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    // const selectedItem = find(flattenItems(menuData, 'children'), ['url', pathname])
    const menuItems = flattenItems(menuData, 'children')
    let selectedItem = find(menuItems, (menu) => {
      if (menu.url === pathname) {
        return true
      }
      return false
    })

    if (selectedItem == null) {
      let curMenu = null
      let mCnt = 0
      const pathArr = pathname.split('/')
      menuItems.forEach((menu) => {
        if (menu.url != null) {
          const urlArr = menu.url.split('/')
          const len = Math.min(urlArr.length, pathArr.length)
          // 0번째는 전부 ''이므로 비교할 필요없음.
          for (let i = 1; i < len; i += 1) {
            if (pathArr[i] === urlArr[i]) {
              if (mCnt < i + 1) {
                mCnt = i + 1
                curMenu = menu
              }
            } else {
              break
            }
          }
        }
      })

      if (curMenu != null) {
        selectedItem = curMenu
      }
    }

    const keys = selectedItem ? [selectedItem.key] : []
    store.set('app.menu.selectedKeys', keys)

    this.setState({
      selectedKeys: keys,
    })
  }

  onCollapse = (_, type) => {
    const { dispatch, isMenuCollapsed } = this.props

    if (type === 'responsive' && isMenuCollapsed) {
      return
    }
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
    this.setState({
      openedKeys: [],
    })
  }

  onOpenChange = (keys) => {
    store.set('app.menu.openedKeys', keys)
    this.setState({
      openedKeys: keys,
    })
  }

  handleClick = (e) => {
    const { dispatch, isSidebarOpen, isMobileView, navigate } = this.props
    // custom action on settings menu item
    if (e.key === 'settings') {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isSidebarOpen',
          value: !isSidebarOpen,
        },
      })
      return
    }

    this.setState({
      selectedKeys: [e.key],
    })

    if (this.menuKeyMap[e.key] != null) {
      if (this.menuKeyMap[e.key].url != null) {
        navigate(this.menuKeyMap[e.key].url)
      }
    }

    if (isMobileView === true) {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileMenuOpen',
          value: false,
        },
      })
    }
  }

  handleInquiryClick = () => {
    const { workspace, userEmail } = this.props
    openInquiryConfirm({
      workspaceName: workspace?.workspace_name,
      contactEmail: userEmail,
    })
  }

  // renderExpandIcon = ({ isOpen }) => {
  //   return <span style={{ marginRight: 8 }}>{isOpen ? <DownOutlined /> : <RightOutlined />}</span>
  // }

  generateMenuItems = () => {
    const { menuData: userMenuData, adminMenuData, menuType, role } = this.props

    const menuData = menuType === 'admin' ? adminMenuData : userMenuData

    this.menuKeyMap = {}

    const generateItem = (item) => {
      const { key, title, icon, disabled, count } = item
      const titleText = title

      if (item.key != null) {
        this.menuKeyMap[item.key] = item
      }

      if (item.category) {
        return {
          type: 'group',
          label: titleText,
          key: Math.random(),
        }
      }

      if (item.divider === true) {
        return {
          type: 'divider',
        }
      }

      let iconElem = null

      if (icon == null || typeof icon === 'string') {
        iconElem = (
          <React.Fragment>
            {count && <span className="badge badge-success ml-2">{count}</span>}
            {icon && <span className={`${icon} ${styles.icon} icon-collapsed-hidden`} />}
          </React.Fragment>
        )
      } else {
        iconElem = (
          <React.Fragment>
            {count && <span className="badge badge-success ml-2">{count}</span>}
            <span className={`${styles.icon}`}>{icon}</span>
          </React.Fragment>
        )
      }

      return {
        label: <span className={styles.title}>{titleText}</span>,
        key,
        disabled,
        icon: iconElem,
      }
    }

    const generateSubmenu = (items) =>
      items.map((menuItem) => {
        if (menuItem.children) {
          const titleText = menuItem.title

          let iconElem = null
          if (menuItem.icon == null || typeof menuItem.icon === 'string') {
            iconElem = (
              <React.Fragment>
                {menuItem.count && (
                  <span className="badge badge-success ml-2">{menuItem.count}</span>
                )}
                {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
              </React.Fragment>
            )
          } else {
            iconElem = (
              <React.Fragment>
                {menuItem.count && (
                  <span className="badge badge-success ml-2">{menuItem.count}</span>
                )}
                <span className={`${styles.icon}`}>{menuItem.icon}</span>
              </React.Fragment>
            )
          }

          return {
            label: <span className={styles.title}>{titleText}</span>,
            key: menuItem.key,
            icon: iconElem,
            children: generateSubmenu(menuItem.children),
          }
        }
        return generateItem(menuItem)
      })

    return menuData.map((menuItem) => {
      if (menuItem.roles && !menuItem.roles.includes(role)) {
        return null
      }

      let iconElem = null
      if (menuItem.icon == null || typeof menuItem.icon === 'string') {
        iconElem = (
          <React.Fragment>
            {menuItem.count && (
              <>
                <span className="badge badge-success ml-2">{menuItem.count}</span>
              </>
            )}
            {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
          </React.Fragment>
        )
      } else {
        iconElem = (
          <React.Fragment>
            {menuItem.count && <span className="badge badge-success ml-2">{menuItem.count}</span>}
            <span className={`${styles.icon}`}>{menuItem.icon}</span>
          </React.Fragment>
        )
      }
      if (menuItem.children) {
        const titleText = menuItem.title
        return {
          label: (
            <>
              <span className={styles.title}>{titleText}</span>
            </>
          ),
          key: menuItem.key,
          icon: iconElem,
          children: generateSubmenu(menuItem.children),
        }
      }
      return generateItem(menuItem)
    })
  }

  render() {
    const { selectedKeys, openedKeys, isMobile } = this.state
    const {
      // isMobileView,
      // isMenuCollapsed,
      menuColor,
      isMenuUnfixed,
      isMenuShadow,
      preElem,
      menuType,
      // logo,
    } = this.props

    const menuSettings = isMobile
      ? {
          collapsible: false,
          collapsed: false,
          onCollapse: this.onCollapse,
          trigger: null,
          width: 240,
        }
      : {
          collapsible: true,
          collapsed: false, // isMenuCollapsed,
          onCollapse: this.onCollapse,
          breakpoint: 'lg',
          trigger: null,
          width: 240,
        }

    const menuItems = this.generateMenuItems()

    return (
      <Layout.Sider
        {...menuSettings}
        className={classNames(`${styles.menu}`, {
          [styles.white]: menuColor === 'white',
          [styles.gray]: menuColor === 'gray',
          [styles.dark]: menuColor === 'dark',
          [styles.unfixed]: isMenuUnfixed,
          [styles.shadow]: isMenuShadow,
        })}
      >
        <div className={styles.menuOuter}>
          <SimpleBar style={{ height: '100%' }}>
            {preElem && <div className={styles.preElem}>{preElem}</div>}
            <Menu
              onClick={this.handleClick}
              selectedKeys={selectedKeys}
              openKeys={openedKeys}
              onOpenChange={this.onOpenChange}
              mode="inline"
              className={styles.navigation}
              inlineIndent="15"
              items={menuItems}
            />
          </SimpleBar>
          {menuType === 'admin' && isGlobal() && (
            <div className={styles.inquiryFooter}>
              <button
                type="button"
                className={styles.inquiryButton}
                onClick={this.handleInquiryClick}
              >
                {i18n.t('inquiryModal.button')}
              </button>
            </div>
          )}
        </div>
      </Layout.Sider>
    )
  }
}

export default connect(mapStateToProps)(withRouter(MenuLeft, { navigate: true }))
